"use client";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import RateContextMenu from "@/app/components/review-product/product-details-rate/RateContextMenu";
import ProductBoxTail from "./product-box-helpers/ProductBoxTail";
import {
  Config_Customize,
  IProduct_Category_Config_Customize,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import {
  ITheme,
  ReviewVisibility,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import useInteractionStart from "@/hooks/useInteractionStart";
import SvgPlus from "./product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/btn-expanding-icons/SvgPlus";
import { usePathname } from "next/navigation";
import { isHomePage } from "@/utils/functions/global-constants";
import { useIsDomReady } from "@/hooks/IsDomReady";
import useSellingMode from "@/hooks/useSellingMode";
import { useState } from "react";
import { useInViewEffect } from "react-hook-inview";
import Attributes from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/Attributes";
import { useProductBox } from "./context/ProductBoxContext";

interface Props extends IProduct {
  scrollableTabs: boolean;
  size: Size;
  theme: ITheme;
  priority: boolean;
  Customize?: Config_Customize;
  isGrid: boolean;
  showCustomEventData?: boolean;
  hideAddToCart?: boolean;
  showAllAttributes?: boolean;
}
const ProductBoxTailAndRate: React.FC<Props> = (props) => {
  const pathname = usePathname();
  const { isInteracting } = useInteractionStart();
  const [isVisible, setIsVisible] = useState(false);
  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
      setIsVisible(entry.isIntersecting);
    },
    { threshold: 0 },
  );
  const {
    setSelectedChildIndex,
    product,
    quick_variant_selection,
    setSelectedAttributes,
  } = useProductBox();
  const { enableAddToCart, isFetching } = useSellingMode();
  const isDomReady = useIsDomReady();
  const homePage = isHomePage(pathname);
  const notShowSkeleton = homePage
    ? isInteracting || (isVisible && isDomReady)
    : isDomReady;
  const { id, theme, rate, ratings, can_review, Customize } = props;
  const showRate =
    theme?.components?.product?.product_reviews_visibility !==
    ReviewVisibility.none;

  return (
    <div ref={ref} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {!notShowSkeleton || isFetching ? (
        <div className="product-tail ">
          <div className={`skeleton-text col-6 p-0`} />
          <div className={`btn-expanded-v-add-to-card skeleton-text`}>
            <div style={{ marginTop: -2 }}>
              <SvgPlus disabled />
            </div>
          </div>
        </div>
      ) : (
        <>
          {showRate && (
            <div className="prodcut-box-rate" style={{ height: 24 }}>
              <RateContextMenu
                rate={rate}
                ratings={ratings}
                productId={id}
                canReview={can_review}
              />
            </div>
          )}
          {quick_variant_selection && (
            <div>
              {product?.attributes_builder?.length > 0 &&
                product?.children?.filter(
                  (child) => child?.attribute_ids?.length > 0,
                ).length > 0 && (
                  <div id="attributes-selector">
                    <Attributes
                      product={product}
                      setSelectedChildIndex={setSelectedChildIndex}
                      setSelectedAttributesValues={setSelectedAttributes}
                      autoSelectFirstChild={false}
                      isProductBox
                      showAllAttributes={props.showAllAttributes}
                    />
                  </div>
                )}
            </div>
          )}
          {enableAddToCart && (
            <ProductBoxTail
              {...props}
              Customize={Customize as IProduct_Category_Config_Customize}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProductBoxTailAndRate;
